import React from 'react';
import './InternalBar.scss';
// import QualifierFlagIcon from "../../../Resources/images/IPL/qualifierFlagIcon.png"

const dividerColorChange = [5, 15, 25, 35, 46, 56, 66, 76, 87, 97];

function ProgressMeter(props) {
	const { width, mileStoneData, data, isQualified, backgroundColor, fillColor } = props;
	let progressBarIntMargin = isQualified ? { 'margin-top': '60px' } : {};
	return (
		<div className="progressBarIntContainer" style={progressBarIntMargin}>
			<div className="progressBarIntContainer__progressBarInt" style={backgroundColor ? {background: backgroundColor} : {}}>
				<span
					className="progressBarIntContainer__progressBarInt__Indicator"
					style={{ width: `${width}%` }}
				>
					<span className="progressBarIntContainer__progressBarInt__Indicator--Fill" style={fillColor ? {backgroundColor: fillColor} : {}}></span>
				</span>
				{/* { !isQualified&&<><div className="progressBarIntContainer__qualifierBar"/>
      <img src={QualifierFlagIcon} className="progressBarIntContainer__qualifierIcon"/></>} */}
			</div>
			{/* <div className="progressBarIntContainer__progressBarIntDividersContainer"> */}
			{/* <><div className="progressBarIntContainer__progressBarIntDividersContainer__completion">
          {data?.completedPercent}
        </div>
          <div className="progressBarIntContainer__progressBarIntDividersContainer__goal">
            Goal:{' '} {data?.goal}
          </div></> */}
			{
				<div className="progressBarIntContainer__progressBarIntDividersContainer__row">
					{mileStoneData?.map((milestone, index) => (
						<progressBarIntDividers
							key={index}
							index={index}
							amount={milestone?.text}
							bgColor={milestone?.bgColor}
							textColor={milestone?.textColor}
							width={width}
						/>
					))}
				</div>
			}
			{/* </div> */}
		</div>
	);
}

const progressBarIntDividers = ({
	index,
	amount,
	bgColor,
	textColor,
	width = 0,
}) => {
	return (
		<div
			className="progressBarIntDividers"
			style={{ marginTop: index % 2 !== 0 ? '19.5px' : '-18px' }}
		>
			{index % 2 === 0 && (
				<div
					className="progressBarIntDividers__priceEmblem progressBarIntDividers__priceEmblem--top"
					style={{
						'background': bgColor,
						'color': textColor,
						'--databgColor': bgColor,
						'marginBottom': '11px',
					}}
				>
					{amount}
				</div>
			)}
			<div
				className="progressBarIntDividers__progressBarIntDividerLines"
				style={{
					background:
						width >= dividerColorChange[index] ? '#FFFFFF' : '#CFCFCF',
				}}
			></div>
			{index % 2 !== 0 && (
				<div
					className="progressBarIntDividers__priceEmblem progressBarIntDividers__priceEmblem--bottom"
					style={{
						'background': bgColor,
						'color': textColor,
						'--databgColor': bgColor,
						'marginTop': '11px',
					}}
				>
					{amount}
				</div>
			)}
		</div>
	);
};

export default ProgressMeter;
